import { AppShell, Burger, Group, Skeleton } from "@mantine/core";
import { PropsWithChildren } from "react";
import { MainLayoutMenu, MainLayoutMenuSpec } from "./MainLayout.Menu";
import { useDisclosure } from "@mantine/hooks";
import { CText } from "./CText";
import classes from './MainLayout.module.scss'
import { ContentContainer } from "./ContentContainer";
import { MainLayoutFooter } from "./MainLayout.Footer";

const menu: MainLayoutMenuSpec[] = [{
  label: 'Home',
  value: 'home',
}, {
  label: 'Our Cars',
  value: 'our-cars',
}, {
  label: 'About Us',
  value: 'aboutUs',
}]

export const MainLayout = ({ children }: PropsWithChildren) => {
  const [opened, { toggle }] = useDisclosure();
  return <AppShell
    header={{ height: 60 }}
    navbar={{ width: 300, breakpoint: 'sm', collapsed: { desktop: true, mobile: !opened } }}
    style={{ width: '100%', overflowX: 'hidden' }}
  >
    <AppShell.Header>
      <ContentContainer className={classes.container}>
        <Group h="100%" px="md">
          <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          <Group justify="space-between" style={{ flex: 1 }}>
            <div className={classes.logoContainer}>
              <img src="assets/logo.png" alt='logo' className={classes.logo} />
              <div className={classes.logoText}>
                <CText fz='lg' >VOYAGER</CText>
                <CText fz='xs' >Premium Cars With a Character</CText>
              </div>
            </div>
            <Group ml="xl" gap={0} visibleFrom="sm" >
              <div className={classes.menuContainer}>
                {menu.map(record => <MainLayoutMenu {...record} key={`menu-${record.value}`} />)}
              </div>
            </Group>
          </Group>
        </Group>
      </ContentContainer>
    </AppShell.Header>

    <AppShell.Navbar py="md" px={4} className={classes.mobileMenuContainer}>

      {menu.map(record => <MainLayoutMenu {...record} key={`menu-${record.value}`} />)}
    </AppShell.Navbar>

    <AppShell.Main>
      {children}
      <MainLayoutFooter />
    </AppShell.Main>
  </AppShell>

}
